var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDailydose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_698_4254",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 500,
    height: 500
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 0H0V500H500V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_698_4254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 0H0V500H500V0Z",
    fill: "#ECECF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.02 220.14C248.02 220.14 228.42 192.92 180.49 206.12C180.49 206.12 178.93 194.78 160.9 196.79C160.9 196.79 153.76 182.62 126.24 186.6C98.7101 190.59 81.3701 159.11 58.2801 167.61C58.2801 167.61 26.4101 157.5 2.3501 181.99C2.3501 181.99 -21.6599 174.79 -34.2599 191.91C-34.2599 191.91 -58.5599 181.14 -78.7999 195.85C-78.7999 195.85 -94.6699 193.94 -101.34 206.51C-108.01 219.08 -88.5799 231.65 -70.8699 224.83C-70.8699 224.83 -66.4299 234.97 -46.2799 239.17C-46.2799 239.17 -28.2199 238.65 -22.6299 250.64C-17.0399 262.63 -0.249878 260.09 -0.249878 260.09C-0.249878 260.09 -7.44989 274.2 -44.8499 266.75C-82.2499 259.3 -91.4899 277.03 -91.4899 277.03C-91.4899 277.03 -106.16 268.29 -118.92 277.57C-131.68 286.85 -155.02 268.22 -174.63 280.36L-173.62 332.14L250.03 323.87L248 220.15L248.02 220.14Z",
    fill: "url(#paint0_linear_698_4254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.76 263.87C256.76 263.87 280.15 231.39 337.33 247.15C337.33 247.15 339.19 233.62 360.7 236.02C360.7 236.02 369.21 219.11 402.06 223.87C434.9 228.63 455.6 191.07 483.14 201.21C483.14 201.21 521.17 189.14 549.87 218.37C549.87 218.37 578.52 209.78 593.55 230.2C593.55 230.2 622.54 217.35 646.69 234.9C646.69 234.9 665.63 232.63 673.59 247.62C681.55 262.61 658.37 277.61 637.23 269.48C637.23 269.48 631.94 281.57 607.89 286.59C607.89 286.59 586.34 285.97 579.68 300.27C573.01 314.57 552.97 311.54 552.97 311.54C552.97 311.54 561.56 328.38 606.18 319.49C650.8 310.6 661.83 331.76 661.83 331.76C661.83 331.76 679.33 321.33 694.55 332.4C709.77 343.47 737.62 321.25 761.02 335.73L759.81 397.51L254.33 387.64L256.75 263.88L256.76 263.87Z",
    fill: "url(#paint1_linear_698_4254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.34 203.71C388.34 203.71 403.99 181.98 442.25 192.52C442.25 192.52 443.5 183.46 457.89 185.07C457.89 185.07 463.59 173.75 485.56 176.94C507.54 180.12 521.39 154.99 539.82 161.78C539.82 161.78 565.27 153.71 584.48 173.26C584.48 173.26 603.65 167.51 613.71 181.18C613.71 181.18 633.11 172.58 649.27 184.32C649.27 184.32 661.94 182.8 667.27 192.83C672.6 202.86 657.08 212.9 642.94 207.46C642.94 207.46 639.4 215.55 623.3 218.91C623.3 218.91 608.88 218.49 604.42 228.06C599.96 237.63 586.55 235.6 586.55 235.6C586.55 235.6 592.3 246.87 622.16 240.92C652.02 234.97 659.4 249.13 659.4 249.13C659.4 249.13 671.11 242.15 681.3 249.56C691.48 256.97 710.12 242.1 725.78 251.79L724.97 293.13L386.71 286.53L388.33 203.71H388.34Z",
    fill: "url(#paint2_linear_698_4254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.09 50.0102C340.09 50.0102 370.36 7.97021 444.38 28.3602C444.38 28.3602 446.79 10.8402 474.63 13.9502C474.63 13.9502 485.65 -7.93979 528.16 -1.77979C570.67 4.38021 597.46 -44.2398 633.11 -31.1098C633.11 -31.1098 682.33 -46.7298 719.49 -8.89978C719.49 -8.89978 756.57 -20.0198 776.03 6.41022C776.03 6.41022 813.56 -10.2198 844.81 12.4902C844.81 12.4902 869.33 9.55021 879.63 28.9602C889.93 48.3702 859.92 67.7802 832.57 57.2502C832.57 57.2502 825.72 72.9002 794.59 79.4002C794.59 79.4002 766.7 78.5902 758.07 97.1102C749.44 115.62 723.5 111.7 723.5 111.7C723.5 111.7 734.62 133.49 792.37 121.99C850.12 110.49 864.4 137.87 864.4 137.87C864.4 137.87 887.06 124.37 906.76 138.7C926.46 153.03 962.5 124.26 992.8 143.01L991.24 222.97L336.96 210.2L340.09 50.0102Z",
    fill: "url(#paint3_linear_698_4254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.59 117.55C326.59 117.55 290.47 67.3904 202.16 91.7204C202.16 91.7204 199.29 70.8204 166.06 74.5304C166.06 74.5304 152.91 48.4104 102.19 55.7604C51.4701 63.1104 19.51 5.10041 -23.0399 20.7604C-23.0399 20.7604 -81.77 2.13041 -126.1 47.2604C-126.1 47.2604 -170.34 34.0004 -193.56 65.5304C-193.56 65.5304 -238.34 45.6804 -275.62 72.7804C-275.62 72.7804 -304.87 69.2704 -317.16 92.4304C-329.45 115.59 -293.65 138.75 -261.01 126.18C-261.01 126.18 -252.84 144.86 -215.69 152.61C-215.69 152.61 -182.42 151.65 -172.12 173.74C-161.82 195.83 -130.88 191.14 -130.88 191.14C-130.88 191.14 -144.15 217.14 -213.06 203.42C-281.97 189.7 -299.01 222.37 -299.01 222.37C-299.01 222.37 -326.04 206.26 -349.55 223.36C-373.06 240.46 -416.06 206.13 -452.21 228.5L-450.35 323.91L330.31 308.67L326.58 117.54L326.59 117.55Z",
    fill: "url(#paint4_linear_698_4254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.38 24.6402C123.38 24.6402 99.2105 -8.91981 40.1105 7.36019C40.1105 7.36019 38.1905 -6.62981 15.9605 -4.13981C15.9605 -4.13981 7.16049 -21.6198 -26.7795 -16.6998C-60.7195 -11.7798 -82.1095 -50.5998 -110.58 -40.1198C-110.58 -40.1198 -149.88 -52.5898 -179.55 -22.3898C-179.55 -22.3898 -209.15 -31.2698 -224.69 -10.1598C-224.69 -10.1598 -254.65 -23.4398 -279.61 -5.30981C-279.61 -5.30981 -299.18 -7.65981 -307.41 7.84019C-315.63 23.3402 -291.68 38.8402 -269.84 30.4302C-269.84 30.4302 -264.37 42.9302 -239.51 48.1202C-239.51 48.1202 -217.24 47.4802 -210.35 62.2602C-203.46 77.0402 -182.75 73.9102 -182.75 73.9102C-182.75 73.9102 -191.63 91.3102 -237.74 82.1302C-283.85 72.9502 -295.25 94.8102 -295.25 94.8102C-295.25 94.8102 -313.34 84.0302 -329.07 95.4702C-344.8 106.91 -373.58 83.9402 -397.77 98.9102L-396.52 162.76L125.88 152.56L123.38 24.6602V24.6402Z",
    fill: "url(#paint5_linear_698_4254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8005 380.02C65.4505 382.16 78.5805 390.31 84.7705 407.63C91.0505 424.95 86.4905 442.64 84.1205 448.3C83.6305 449.58 82.5406 449.7 81.9506 448.57C79.2006 443.12 72.1505 429.66 67.0905 415.3C62.2305 400.89 60.1505 387.16 59.1405 381.42C58.9505 380.24 59.7805 379.51 60.8105 380.01L60.8005 380.02Z",
    fill: "#C3C3DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6301 380.2C61.2101 382.55 62.7601 384.94 64.2101 387.42C65.6901 389.88 67.0901 392.41 68.4001 395.01C71.0301 400.21 73.4001 405.65 75.3901 411.33C77.4001 417.01 79.0401 422.92 80.3301 429.03C80.9801 432.08 81.5201 435.19 81.9501 438.34C82.4101 441.48 82.7401 444.68 83.0001 447.91C82.9401 444.65 82.7101 441.44 82.3901 438.25C82.0401 435.07 81.5801 431.94 81.0101 428.84C79.8701 422.66 78.2401 416.69 76.2301 410.96C74.2001 405.25 71.7901 399.77 69.0001 394.63C67.6001 392.06 66.1301 389.56 64.5701 387.14C62.9901 384.74 61.3601 382.4 59.6201 380.18L59.6301 380.2Z",
    fill: "#ECECF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.67 395.11C106.37 398.7 110.1 410.08 105.13 423.46C100.22 436.88 88.6903 445.11 84.4603 447.29C83.5303 447.81 82.8203 447.33 83.0403 446.36C84.1303 441.76 86.6503 430.24 90.8003 419.19C95.1003 408.21 100.71 399.02 102.97 395.1C103.45 394.3 104.3 394.29 104.67 395.1V395.11Z",
    fill: "#C3C3DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.89 394.63C103.66 396.81 103.39 399.01 103.01 401.2C102.66 403.4 102.23 405.6 101.71 407.8C100.68 412.2 99.37 416.61 97.72 420.98C96.08 425.35 94.11 429.69 91.83 433.95C90.69 436.08 89.47 438.2 88.15 440.28C86.86 442.38 85.46 444.44 84 446.49C85.59 444.53 87.05 442.5 88.45 440.45C89.83 438.39 91.12 436.29 92.32 434.18C94.73 429.94 96.73 425.58 98.39 421.18C100.03 416.77 101.33 412.32 102.24 407.88C102.69 405.66 103.06 403.44 103.34 401.23C103.6 399.02 103.8 396.82 103.87 394.63H103.89Z",
    fill: "#ECECF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.44 394.63C460.84 396.28 450.7 402.58 445.91 415.98C441.05 429.37 444.58 443.05 446.41 447.43C446.79 448.42 447.63 448.51 448.09 447.64C450.21 443.43 455.67 433.02 459.58 421.92C463.33 410.78 464.95 400.16 465.73 395.72C465.88 394.81 465.23 394.24 464.44 394.63Z",
    fill: "#C3C3DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.35 394.77C464.13 396.59 462.93 398.44 461.81 400.35C460.67 402.25 459.59 404.21 458.57 406.22C456.53 410.24 454.71 414.45 453.17 418.84C451.61 423.23 450.35 427.8 449.35 432.52C448.85 434.88 448.43 437.28 448.1 439.72C447.74 442.15 447.49 444.62 447.29 447.12C447.33 444.6 447.52 442.11 447.76 439.65C448.03 437.19 448.39 434.77 448.83 432.38C449.71 427.6 450.97 422.98 452.53 418.56C454.1 414.14 455.96 409.91 458.12 405.94C459.2 403.95 460.34 402.02 461.54 400.15C462.76 398.3 464.02 396.49 465.36 394.77H465.35Z",
    fill: "#ECECF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.52 406.29C429.21 409.07 426.32 417.87 430.16 428.21C433.96 438.59 442.87 444.95 446.14 446.63C446.86 447.03 447.41 446.66 447.24 445.91C446.4 442.35 444.45 433.45 441.24 424.9C437.91 416.41 433.58 409.3 431.83 406.28C431.46 405.66 430.8 405.65 430.52 406.28V406.29Z",
    fill: "#C3C3DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.119 405.92C431.299 407.61 431.509 409.31 431.799 411C432.069 412.7 432.399 414.4 432.799 416.1C433.599 419.5 434.609 422.91 435.889 426.29C437.149 429.67 438.679 433.02 440.439 436.32C441.319 437.97 442.269 439.6 443.289 441.22C444.289 442.84 445.369 444.43 446.499 446.02C445.269 444.5 444.139 442.93 443.059 441.35C441.999 439.76 440.999 438.14 440.069 436.5C438.209 433.22 436.659 429.85 435.369 426.45C434.099 423.04 433.089 419.6 432.389 416.16C432.039 414.44 431.759 412.73 431.539 411.02C431.339 409.31 431.189 407.61 431.129 405.92H431.119Z",
    fill: "#ECECF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.22 470.55C385.323 470.55 487.55 463.109 487.55 453.93C487.55 444.751 385.323 437.31 259.22 437.31C133.116 437.31 30.8896 444.751 30.8896 453.93C30.8896 463.109 133.116 470.55 259.22 470.55Z",
    fill: "#C3C3DD"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.01 135.56L142.58 138.43L145.46 140L142.58 141.57L141.01 144.44L139.44 141.57L136.57 140L139.44 138.43L141.01 135.56Z",
    fill: "#FDC73A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 83.3701L175.29 85.2401L177.16 86.2701L175.29 87.2901L174.27 89.1601L173.25 87.2901L171.38 86.2701L173.25 85.2401L174.27 83.3701Z",
    fill: "#FDC73A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.32 84.2998L130.94 87.2498L133.9 88.8698L130.94 90.4898L129.32 93.4498L127.7 90.4898L124.74 88.8698L127.7 87.2498L129.32 84.2998Z",
    fill: "#FDC73A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M362.03 107.92L363.6 110.79L366.48 112.36L363.6 113.93L362.03 116.8L360.46 113.93L357.59 112.36L360.46 110.79L362.03 107.92Z",
    fill: "#FDC73A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M388.29 70.98L389.31 72.85L391.18 73.87L389.31 74.9L388.29 76.77L387.27 74.9L385.4 73.87L387.27 72.85L388.29 70.98Z",
    fill: "#FDC73A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M392.4 186.35L394.01 189.3L396.97 190.92L394.01 192.54L392.4 195.5L390.78 192.54L387.82 190.92L390.78 189.3L392.4 186.35Z",
    fill: "#FDC73A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M267.9 104.25L269.51 107.21L272.47 108.83L269.51 110.44L267.9 113.4L266.28 110.44L263.32 108.83L266.28 107.21L267.9 104.25Z",
    fill: "#FDC73A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M335.79 377.38L346.06 385L336.63 399.22L322.34 390.31L335.79 377.38Z",
    fill: "#AC685A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M333.77 398.85L329.14 416.38L334.2 422.8L357.92 387.02L345.12 381.73L333.77 398.85Z",
    fill: "#001E34"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M355.54 385.44L337.73 412.43C337.73 412.43 332.14 409.62 328.29 415.41C324.45 421.21 332.57 427.99 332.57 427.99L359.31 387.65L355.54 385.44Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M334.569 400.131L330.149 397.961L335.059 390.561L339.299 394.441L335.379 400.361L334.569 400.131Z",
    fill: "#001E34"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M338.24 379.2L331.46 395.99L328.38 394.07L338.24 379.2Z",
    fill: "#8D463C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M408.229 339.1L420.949 340.34L420.199 357.38L403.359 357.11L408.229 339.1Z",
    fill: "#AC685A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M417.56 358.54L422.62 375.95L430.27 378.85L432.16 335.96L418.46 338.02L417.56 358.54Z",
    fill: "#001E34"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M429.3 335.83L427.94 368.14C427.94 368.14 421.7 368.61 421.39 375.56C421.08 382.51 431.54 384.13 431.54 384.13L433.67 335.77L429.3 335.82V335.83Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M418.899 359.23L413.999 359.65L414.389 350.77L420.029 351.91L419.709 359.01L418.899 359.23Z",
    fill: "#001E34"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M411.26 339.39L414.099 357.29L410.479 357.23L411.26 339.39Z",
    fill: "#8D463C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M282.26 216.45L262.18 335.36C260.84 343.27 263.81 351.3 269.97 356.44L325.16 399.21L339.71 376.16L294.41 334.9L316.58 268.03V218.66L282.26 216.46V216.45Z",
    fill: "#020017"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M307.17 211.36L321.05 340.4C321.8 347.42 327.3 353 334.31 353.85L410.33 363.12L412.11 336.78L359.64 328L343.31 216.45L307.17 211.35V211.36Z",
    fill: "#020017"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M346.14 242.03C340.65 242.03 336.41 240.5 333.56 237.47C329.4 233.06 329.69 227.12 329.7 226.87L330.38 226.91C330.38 226.97 330.09 232.81 334.06 237.01C336.78 239.89 340.85 241.35 346.15 241.35V242.03H346.14Z",
    fill: "#001E34"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M279.229 242.03V241.35C284.529 241.35 288.59 239.89 291.32 237.01C295.28 232.81 295 226.97 295 226.91L295.68 226.87C295.69 227.12 295.99 233.05 291.82 237.47C288.97 240.49 284.73 242.03 279.24 242.03H279.229Z",
    fill: "#001E34"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M216.12 85.9004C232.28 123.86 236.25 139.94 284.78 171.99L282.89 149.28L251.76 122.34L226.11 80.1904L216.12 85.8904V85.9004Z",
    fill: "#AC685A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M414.64 87.2303L393.43 137.01C393.43 137.01 361.62 166.55 335.1 172.14L340.57 147.01C387.92 125.29 377.28 127.57 404.22 82.0303L414.64 87.2403V87.2303Z",
    fill: "#AC685A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M324.56 139.11H301.44C282.5 139.11 274.13 155.68 276.43 174.48L280.2 225.39H346.15L348.06 195.25L350.75 174.47C353.05 155.67 343.5 139.1 324.56 139.1V139.11Z",
    fill: "#33AA94"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M298.74 139.22C298.74 139.22 297.63 148.94 310.86 148.94C324.09 148.94 328.19 139.31 328.19 139.31L313.68 137.34L298.74 139.22Z",
    fill: "#AC685A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M295.209 102.8L294.149 91.98L297.979 94.76L295.209 102.8Z",
    fill: "#001E34"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M213.39 91.8101L232.15 81.0801L252.06 118.11C253.55 120.89 255.66 123.29 258.22 125.13L272.12 135.12C278.6 139.87 284.41 141.34 291.22 140.33L298.74 139.22L276.18 171.98L241.16 139.58C239.55 138.09 238.19 136.36 237.12 134.44L213.39 91.8001V91.8101Z",
    fill: "#33AA94"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M415.749 93.3801L398.589 83.8301L382.799 115.43C380.299 119.96 376.739 123.81 372.409 126.65L356.089 137.34C349.659 141.12 342.529 141.33 335.709 140.33L328.189 139.22L350.749 171.98L389.069 143.49C393.449 140.23 396.919 135.89 399.129 130.9L415.759 93.3701L415.749 93.3801Z",
    fill: "#33AA94"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M314.15 276.26L310.87 253.25",
    stroke: "#032335",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M306.08 253.89L316.28 252.54",
    stroke: "#032335",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M321.93 129.37H304.87L304.67 137.79C304.55 142.69 308.5 146.73 313.4 146.73C318.3 146.73 322.25 142.69 322.13 137.79L321.93 129.37Z",
    fill: "#AC685A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M304.75 131.15C304.75 131.15 308.5 137.98 321.97 133.57L321.94 129.37H304.88L304.76 131.15H304.75Z",
    fill: "#8D463C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M292.92 111.51C294 114.55 296.87 116.23 299.33 115.26C301.79 114.29 302.9 111.04 301.82 108C300.74 104.96 297.87 103.28 295.41 104.25C292.95 105.22 291.84 108.47 292.92 111.51Z",
    fill: "#AC685A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M294.519 101.05C294.519 100.97 294.499 100.89 294.489 100.81V100.79C294.429 100.17 294.399 99.5503 294.399 98.9203C294.399 88.5303 302.919 80.1104 313.429 80.1104C323.939 80.1104 332.459 88.5303 332.459 98.9203C332.459 99.5503 332.429 100.18 332.369 100.79V100.81C332.359 100.89 332.349 100.97 332.339 101.05L330.459 115.12C330.109 117.74 329.379 120.3 328.179 122.66C324.929 129.06 319.529 132.37 310.899 132.37C302.269 132.37 297.799 126.13 296.599 118L296.579 117.8C296.549 117.59 296.519 117.39 296.499 117.18L294.539 101.06L294.519 101.05Z",
    fill: "#AC685A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M308.48 116.11L308.53 115.45C307.62 115.38 307.04 115.1 306.81 114.6C306.25 113.37 307.7 110.98 308.31 110.16L307.78 109.76C307.68 109.89 305.37 113.03 306.21 114.87C306.55 115.61 307.31 116.03 308.48 116.11Z",
    fill: "#001E34"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M314.564 102.603L314.165 104.337L320.938 105.895L321.337 104.16L314.564 102.603Z",
    fill: "#001E34"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M304.643 102.631L299.181 104.188L299.668 105.899L305.131 104.343L304.643 102.631Z",
    fill: "#001E34"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M303.9 108.71C303.9 109.37 303.36 109.91 302.7 109.91C302.04 109.91 301.5 109.37 301.5 108.71C301.5 108.05 302.04 107.51 302.7 107.51C303.36 107.51 303.9 108.05 303.9 108.71Z",
    fill: "#001E34"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M317.74 108.71C317.74 109.37 317.2 109.91 316.54 109.91C315.88 109.91 315.34 109.37 315.34 108.71C315.34 108.05 315.88 107.51 316.54 107.51C317.2 107.51 317.74 108.05 317.74 108.71Z",
    fill: "#001E34"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M334.68 111.51C333.6 114.55 330.73 116.23 328.27 115.26C325.81 114.29 324.7 111.04 325.78 108C326.86 104.96 329.73 103.28 332.19 104.25C334.65 105.22 335.76 108.47 334.68 111.51Z",
    fill: "#AC685A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M333.239 111.92C333.279 111.78 334.249 108.37 331.799 106.45L331.529 106.8C333.739 108.54 332.819 111.77 332.809 111.8L333.239 111.93V111.92Z",
    fill: "#001E33"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M314.47 118.87L304.79 120.02C304.79 120.02 306.02 123.95 309.63 123.82C313.83 123.68 314.47 118.86 314.47 118.86V118.87Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M313.1 81.4603C313.1 81.4603 294.84 81.1703 294.16 99.3903C294.1 101.09 294.23 102.79 294.48 104.48L295.48 108.98C295.48 108.98 298.45 104.89 300.61 98.3703L313.1 98.3303H324.57C326.73 104.85 331.05 108.98 331.05 108.98L331.91 104.15C332.16 102.47 332.1 101.09 332.04 99.3903C331.36 81.1603 313.1 81.4603 313.1 81.4603Z",
    fill: "#001E34"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M331.91 104.15C334.88 90.9302 336.28 84.3202 326.46 83.9602C326.46 83.9602 318.65 75.4102 305.96 75.9402C293.27 76.4702 297.38 83.8402 297.38 83.8402C297.38 83.8402 283.56 83.8402 296.06 97.2402L315.15 89.4002L328.38 94.3102L331.91 104.15Z",
    fill: "#001E34"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M414.64 87.2302C414.64 87.2302 425.13 78.5403 424.49 72.3003C424.49 72.3003 424.62 70.7803 422.51 70.0403C422.51 70.0403 423.62 67.9803 421.15 66.5203C421.15 66.5203 421.91 64.8803 419.68 63.8203C419.68 63.8203 418.76 61.3603 415.47 61.9103C407.01 64.0803 405.72 74.5403 403.5 85.0003L414.65 87.2403L414.64 87.2302Z",
    fill: "#AC685A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M420.26 75.47C419.11 75.09 418.48 73.12 418.48 73.05L419.1 72.87C419.99 77.11 423.73 73.08 424.23 72.29L424.75 72.67C424.83 72.63 422 76.12 420.25 75.47H420.26Z",
    fill: "#032335"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M412.56 69.0401C412.56 69.0401 415.19 72.2201 417.65 71.5601C420.11 70.9001 418.61 67.2701 418.61 67.2701C418.61 67.2701 416.23 62.4201 413.3 62.5601C413.3 62.5601 411.18 63.7701 409.97 65.3801L412.57 69.0401H412.56Z",
    fill: "#AC685A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M424.67 72.9802C424.31 73.9202 423.31 75.3702 420.48 75.7702C420.48 75.7702 418.5 74.7302 418.68 73.2902C418.68 73.2902 416.5 73.2502 416.17 71.9002L416.89 70.2802L418.83 68.1202C418.83 68.1202 420.2 66.6402 421.39 66.2202C421.39 66.2202 423.97 67.8302 422.8 70.1702C422.8 70.1702 423.81 70.4702 424.46 71.3302C424.81 71.8002 424.88 72.4202 424.67 72.9802Z",
    fill: "#AC685A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M417.32 64.9302C417.32 64.9302 420.04 66.4802 419.65 67.3502C419.62 67.4202 418.75 68.4802 418.75 68.4802L417.32 65.2102V64.9302Z",
    fill: "#AC685A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M412.88 62.5903C412.88 62.5903 414.98 62.6003 416.17 63.9103C418.22 66.1503 420.47 70.7103 417.64 71.5603C414.81 72.4103 414.24 68.3503 414.24 68.3503",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M417.2 65.2003C417.2 65.2003 418.66 63.8603 419.57 63.5903",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M418.68 68.0701C418.68 68.0701 420.04 66.6501 421.39 66.1201",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M416.36 71.6005C416.36 71.6005 417.6 73.9505 419.74 72.5805C421.88 71.2005 422.81 70.0205 422.81 70.0205",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M418.5 73.1702C418.5 73.1702 419.5 76.4102 421.39 75.5802C423.29 74.7602 424.67 72.9702 424.67 72.9702",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M413.79 76.0703C413.79 76.0703 415.63 78.6403 413.92 80.4203",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M216.12 85.9002C216.12 85.9002 205.13 75.7102 205.77 69.4702C205.77 69.4702 205.64 67.9502 207.75 67.2102C207.75 67.2102 206.64 65.1502 209.11 63.6902C209.11 63.6902 208.35 62.0502 210.58 60.9902C210.58 60.9902 211.5 58.5302 214.79 59.0802C223.25 61.2502 223.88 69.7502 226.1 80.2002L216.11 85.9002H216.12Z",
    fill: "#AC685A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M209.999 72.64C211.149 72.26 211.779 70.29 211.779 70.22L211.159 70.04C210.269 74.28 206.529 70.25 206.029 69.46L205.509 69.84C205.429 69.8 208.259 73.29 210.009 72.64H209.999Z",
    fill: "#032335"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M217.71 66.21C217.71 66.21 215.08 69.39 212.62 68.73C210.16 68.07 211.66 64.44 211.66 64.44C211.66 64.44 214.04 59.59 216.97 59.73C216.97 59.73 219.09 60.94 220.3 62.55L217.7 66.21H217.71Z",
    fill: "#AC685A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M205.59 70.1501C205.95 71.0901 206.95 72.5401 209.78 72.9401C209.78 72.9401 211.76 71.9001 211.58 70.4601C211.58 70.4601 213.76 70.4201 214.09 69.0701L213.37 67.4501L211.43 65.2901C211.43 65.2901 210.06 63.8101 208.87 63.3901C208.87 63.3901 206.29 65.0001 207.46 67.3401C207.46 67.3401 206.45 67.6401 205.8 68.5001C205.45 68.9701 205.38 69.5901 205.59 70.1501Z",
    fill: "#AC685A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M212.95 62.1001C212.95 62.1001 210.23 63.6501 210.62 64.5201C210.65 64.5901 211.52 65.6501 211.52 65.6501L212.95 62.3801V62.1001Z",
    fill: "#AC685A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M217.38 59.7603C217.38 59.7603 215.28 59.7703 214.09 61.0803C212.04 63.3203 209.79 67.8802 212.62 68.7302C215.45 69.5802 216.02 65.5202 216.02 65.5202",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M213.07 62.3703C213.07 62.3703 211.61 61.0303 210.7 60.7603",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M211.58 65.2503C211.58 65.2503 210.22 63.8303 208.87 63.3003",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M213.9 68.7704C213.9 68.7704 212.66 71.1204 210.52 69.7504C208.38 68.3704 207.45 67.1904 207.45 67.1904",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M211.77 70.3504C211.77 70.3504 210.77 73.5904 208.88 72.7604C206.98 71.9404 205.6 70.1504 205.6 70.1504",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M216.47 73.2402C216.47 73.2402 214.63 75.8102 216.34 77.5902",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M312.489 152.01C324.159 151.28 329.679 144.45 331.599 141.36",
    stroke: "#001E34",
    strokeWidth: 0.49,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M295.029 141.09C295.219 144.05 296.809 150.9 307.529 151.94V161.96",
    stroke: "#001E34",
    strokeWidth: 0.49,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M308.97 154.23C308.97 153.69 309.41 153.24 309.96 153.24C310.51 153.24 310.95 153.68 310.95 154.23C310.95 154.78 310.51 155.22 309.96 155.22C309.41 155.22 308.97 154.78 308.97 154.23Z",
    fill: "#001E34"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M308.97 159.9C308.97 159.36 309.41 158.91 309.96 158.91C310.51 158.91 310.95 159.35 310.95 159.9C310.95 160.45 310.51 160.89 309.96 160.89C309.41 160.89 308.97 160.45 308.97 159.9Z",
    fill: "#001E34"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M206.54 103.3C186.23 102.35 177.49 122.21 181.08 140.02C184.67 157.84 167.69 163.41 177.2 194.88L202.63 186.93L206.55 103.29L206.54 103.3Z",
    fill: "#001E33"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M206.54 103.301C224.73 104.151 233.69 124.841 228.45 142.241C223.21 159.641 239.47 165.751 227.07 196.191L202.62 186.931L206.54 103.291V103.301Z",
    fill: "#001E33"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M198.68 439.86L199.12 422.58L183.68 421.68L183.1 442.41L198.68 439.86Z",
    fill: "#FFAFA3"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M185.83 438.291L164.12 443.661L161.65 451.381L200.09 452.241L199.09 438.661L185.83 438.291Z",
    fill: "#001E34"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M200.43 447.11L171.25 446.51C171.25 446.51 169.95 441.85 164.46 441.73C158.23 441.59 156.94 452.61 156.94 452.61L200.5 453.59L200.43 447.11Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M192.731 442.961C192.621 445.811 197.101 445.911 197.121 443.061C197.231 440.211 192.751 440.111 192.731 442.961Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M188.65 439.25L189.23 435.29L182.4 435.13L182.98 439.77L188.44 439.9L188.65 439.25Z",
    fill: "#001E34"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M255.71 179.86C255.71 179.86 256.95 174.45 257.53 172.16C258.31 169.03 259.91 164.73 260.27 162.65C260.59 160.83 263.25 151.16 265.41 151.32C268.11 151.52 264.93 163.19 264.93 163.19C264.93 163.19 270.39 151.15 272.74 151.97C276.12 153.15 269.14 163.66 269.14 163.66C269.14 163.66 274.02 163.19 272.47 167.57C272.47 167.57 275.34 167.93 274 171.59C274 171.59 273.02 174.31 270.78 177.35C270.78 177.35 268.05 181 266.41 183.07C266.41 183.07 259.2 184.21 255.71 179.86Z",
    fill: "#FFAFA3"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M258.81 170.66C258.81 170.66 266.87 165.64 268.91 168.18C270.43 170.08 262.44 173.82 262.44 173.82",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M267.27 167.46C267.66 166.33 268.2 165.25 269.25 163.47",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M269.31 172.58C269.02 172.5 267.27 172.15 266.87 171.28",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M227.85 200.82C227.85 200.82 231.65 233.08 247.65 232.39C263.65 231.7 269.04 182.07 269.04 182.07L253.28 178.11L248 198.54C248 198.54 245.24 168.23 218.38 162.12L214.28 207.51L227.85 200.82Z",
    fill: "#100C41"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M248.01 198.55C248.01 198.55 249.19 208.89 248.01 212.41",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M272.47 167.561C272.47 167.561 268.28 171.971 269.6 174.161C270.91 176.351 272.47 174.091 272.47 174.091",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4902 159.42C93.4902 159.42 86.3402 156.8 82.7502 154.32C79.4002 152 71.0602 150.09 69.9902 151.62C69.2902 152.61 69.7002 153.62 69.7002 153.62C69.7002 153.62 60.5202 149.81 59.7702 152.44C59.0202 155.07 69.9902 157.4 69.9902 157.4C69.9902 157.4 68.7902 159.73 70.6702 160.71C70.6702 160.71 70.3702 163.56 72.5502 164.24C72.5502 164.24 72.9302 166.87 75.5502 167.17C78.1702 167.47 81.7902 168.04 84.0802 167.86C87.0102 167.63 90.8402 169.32 90.8402 169.32C90.8402 169.32 93.2002 162.79 93.5002 159.41L93.4902 159.42Z",
    fill: "#FFAFA3"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M195.27 160.891C195.27 160.891 179.77 163.401 161.06 167.681L140.03 172.211C136.56 173.081 132.91 172.861 129.58 171.591L91.8004 156.101L85.6104 171.371L124.96 192.481C127.8 193.891 130.96 194.491 134.12 194.231L176.29 190.771L186.26 165.291L195.27 160.881V160.891Z",
    fill: "#100C41"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M181.72 227.49C171.29 244.61 164.62 269.46 166.11 289.46L180.21 430.29H201.07L204.33 227.5H181.72V227.49Z",
    fill: "#31A1F9"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M245.16 350.14L229.74 342.32L222.29 355.87L240.76 365.31L245.16 350.14Z",
    fill: "#FFAFA3"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M240.39 271.57C238.13 256 231.25 245.64 223.78 233.37L202.65 227.49L175.87 287.94L156.26 302.26C146.17 309.63 147.65 325.1 158.94 330.43L226.04 362.08L238.43 339.9L203.6 314.44L207.89 313.89C217.44 312.67 226.16 307.83 232.25 300.38C238.84 292.32 241.9 281.87 240.4 271.56L240.39 271.57Z",
    fill: "#31A1F9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M218.45 271.951L188.73 269.541V232.391H218.45V271.951Z",
    fill: "#31A1F9"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M230.18 248.911C220.47 246.541 219.07 236.271 219.06 236.171L219.76 236.081C219.77 236.181 221.11 245.981 230.35 248.231L230.18 248.911Z",
    fill: "#032335"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M174.88 249.831L174.71 249.151C183.96 246.901 185.29 237.1 185.3 237L186 237.091C185.99 237.191 184.59 247.461 174.88 249.831Z",
    fill: "#032335"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M226.74 192.9C227.19 192.79 227.68 192.73 228.2 192.73L226.5 191.63L221.5 166.02C222.18 163.03 219.96 161.76 210.67 160.89C205.71 160.52 200.72 161.26 195.76 161.63L195.28 160.89C175.45 162.67 166.5 173.07 171.38 190.78L172.52 190.9C174.34 197.82 177.68 203.15 177.68 203.15L178.08 234.07C178.08 234.07 201.95 246.88 224.73 234.89L228.83 203.61L226.74 192.9Z",
    fill: "#100C41"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M231.53 186.34C231.53 186.34 237.48 201.12 223.16 206L221.19 193.81L231.53 186.34Z",
    fill: "#100C41"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M172.85 185.561C172.85 185.561 168.53 204.841 185.74 210.191C185.74 210.191 187.36 195.681 187.29 195.901C187.22 196.121 172.85 185.561 172.85 185.561Z",
    fill: "#100C41"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M228.567 202.641L227.231 212.33L227.905 212.422L229.241 202.734L228.567 202.641Z",
    fill: "#032335"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M200.81 272.041L166.41 294.431L166.87 295.141L201.51 272.601C201.25 272.431 201.02 272.251 200.81 272.041Z",
    fill: "#032335"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M194.22 268.021C194.03 268.241 193.84 268.46 193.63 268.66L200.99 272.951L201.72 272.451L194.23 268.021H194.22Z",
    fill: "#032335"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M170.99 335.673L170.627 336.442L202.208 351.343L202.571 350.574L170.99 335.673Z",
    fill: "#032335"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M199.511 312.846L199.284 313.665L203.438 314.816L203.665 313.997L199.511 312.846Z",
    fill: "#032335"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M239.721 361.801L239.641 384.171L246.531 388.441L256.731 351.371L243.311 349.041L239.721 361.801Z",
    fill: "#001E34"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M251.83 349.791L244.15 377.951C244.15 377.951 239.31 378.071 237.86 383.371C236.21 389.381 246.59 393.311 246.59 393.311L258.15 351.301L251.84 349.791H251.83Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M245.931 356.241C248.671 357.041 249.851 352.721 247.091 352.011C244.351 351.211 243.171 355.531 245.931 356.241Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M241.34 359.301L237.64 357.781L235.82 364.361L240.47 364.931L241.92 359.661L241.34 359.301Z",
    fill: "#001E34"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M196.58 202.781C196.58 201.991 197.22 201.351 198.01 201.351C198.8 201.351 199.44 201.991 199.44 202.781C199.44 203.571 198.8 204.211 198.01 204.211C197.22 204.211 196.58 203.571 196.58 202.781Z",
    fill: "#032335"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M196.58 215.701C196.58 214.911 197.22 214.271 198.01 214.271C198.8 214.271 199.44 214.911 199.44 215.701C199.44 216.491 198.8 217.13 198.01 217.13C197.22 217.13 196.58 216.491 196.58 215.701Z",
    fill: "#032335"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M196.58 228.61C196.58 227.82 197.22 227.18 198.01 227.18C198.8 227.18 199.44 227.82 199.44 228.61C199.44 229.4 198.8 230.04 198.01 230.04C197.22 230.04 196.58 229.4 196.58 228.61Z",
    fill: "#032335"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9805 107.57H58.2505C59.2005 107.57 59.9705 108.34 59.9705 109.29V138.81C59.9705 139.76 59.2005 140.53 58.2505 140.53H39.9805V107.58V107.57Z",
    fill: "#33AA94"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M57.71 107.57H40.27C39.5686 107.57 39 108.139 39 108.84V139.25C39 139.952 39.5686 140.52 40.27 140.52H57.71C58.4114 140.52 58.98 139.952 58.98 139.25V108.84C58.98 108.139 58.4114 107.57 57.71 107.57Z",
    fill: "#33AA94"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9902 123.61C50.2329 123.61 51.2402 122.603 51.2402 121.36C51.2402 120.118 50.2329 119.11 48.9902 119.11C47.7476 119.11 46.7402 120.118 46.7402 121.36C46.7402 122.603 47.7476 123.61 48.9902 123.61Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6902 109.311H41.7502C41.3305 109.311 40.9902 109.651 40.9902 110.071V114.691C40.9902 115.11 41.3305 115.451 41.7502 115.451H46.6902C47.11 115.451 47.4502 115.11 47.4502 114.691V110.071C47.4502 109.651 47.11 109.311 46.6902 109.311Z",
    fill: "#001E34"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5801 110.671C41.5801 110.181 41.9701 109.791 42.4601 109.791C42.9501 109.791 43.3401 110.181 43.3401 110.671C43.3401 111.161 42.9501 111.551 42.4601 111.551C41.9701 111.551 41.5801 111.161 41.5801 110.671Z",
    fill: "#02131E"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4698 114.54C42.9559 114.54 43.3499 114.146 43.3499 113.66C43.3499 113.174 42.9559 112.78 42.4698 112.78C41.9838 112.78 41.5898 113.174 41.5898 113.66C41.5898 114.146 41.9838 114.54 42.4698 114.54Z",
    fill: "#02131E"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8496 110.671C44.8496 110.181 45.2396 109.791 45.7296 109.791C46.2196 109.791 46.6096 110.181 46.6096 110.671C46.6096 111.161 46.2196 111.551 45.7296 111.551C45.2396 111.551 44.8496 111.161 44.8496 110.671Z",
    fill: "#02131E"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8496 113.66C44.8496 113.17 45.2396 112.78 45.7296 112.78C46.2196 112.78 46.6096 113.17 46.6096 113.66C46.6096 114.15 46.2196 114.54 45.7296 114.54C45.2396 114.54 44.8496 114.15 44.8496 113.66Z",
    fill: "#02131E"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6201 141.351L101.45 181.671",
    stroke: "#001E34",
    strokeWidth: 2.03,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M56.29 139.041H42.5V143.091H56.29V139.041Z",
    fill: "#001E34"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0303 129.351V141.671",
    stroke: "#001E34",
    strokeWidth: 1.01,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1299 129.351V141.671",
    stroke: "#001E34",
    strokeWidth: 1.01,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M91.96 174.28L100.64 181.04",
    stroke: "#001E34",
    strokeWidth: 5.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0898 168.61C84.0898 168.61 95.4199 156.49 90.3499 153.93C87.8499 152.67 86.4199 154.17 85.6099 156.02",
    stroke: "#001E34",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2501 154C82.2501 154 73.2 149.47 69.97 151.78C69.97 151.78 68.7501 152.9 71.1901 155C73.6301 157.1 79.74 156.88 79.74 156.88L82.2501 154Z",
    fill: "#FFAFA3"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6701 151.56C75.6701 151.56 68.0501 149.85 69.9901 153.63C71.5501 156.69 77.7501 156.83 77.7501 156.83",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2703 167.131L76.5504 166.611C76.5504 166.611 82.6303 165.381 80.7803 162.311C80.7803 162.311 82.4604 160.521 80.4904 159.621C80.4904 159.621 81.3303 157.871 80.4503 157.171C79.5703 156.471 75.3903 156.981 75.3903 156.981L69.9904 157.401C69.9904 157.401 68.7604 159.641 70.6704 160.711C70.6704 160.711 70.2904 163.711 72.5504 164.241C72.5504 164.241 72.9003 166.731 75.2803 167.131H75.2703Z",
    fill: "#FFAFA3"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9902 157.4C69.9902 157.4 74.6902 156.99 78.3702 156.8C82.0502 156.61 80.4402 159.35 80.4402 159.35",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8503 166.74C75.8503 166.74 82.0803 165.75 81.0603 162.94C80.0503 160.12 72.5303 164.24 72.5303 164.24",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7101 162.4C80.7101 162.4 82.4802 160.32 80.2802 159.53C78.0802 158.74 70.6602 160.7 70.6602 160.7",
    stroke: "#032335",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M186.47 162.44C186.47 162.44 181.59 190.02 198.42 197.26C198.42 197.26 216.55 191.41 218.27 162.09C218.27 162.09 206.64 159.71 202.87 159.34C202.87 159.34 189.46 160.93 186.46 162.45L186.47 162.44Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M210.3 152.021H194.95L194.77 159.601C194.67 164.011 198.21 167.641 202.63 167.641C207.04 167.641 210.59 164.011 210.49 159.601L210.31 152.021H210.3Z",
    fill: "#FFAFA3"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M194.9 154.081C194.9 154.081 198.36 161.361 210.48 157.391L210.3 152.021H194.95L194.9 154.081Z",
    fill: "#D9817C"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M219.72 128.62C219.73 128.55 219.75 128.47 219.76 128.4V128.381C219.84 127.821 219.89 127.26 219.92 126.68C220.36 117.25 213.41 109.26 204.39 108.84C195.37 108.42 187.7 115.72 187.26 125.15C187.23 125.72 187.23 126.291 187.26 126.851V126.87C187.26 126.94 187.27 127.01 187.28 127.09L188.28 141.87C188.28 141.87 188.28 141.931 188.28 141.961L188.3 142.31C188.88 149.85 196.46 156 202.15 156.271C207.78 156.53 215.83 151.23 217.21 143.91L217.24 143.73C217.27 143.54 217.3 143.36 217.33 143.17L219.7 128.62H219.72Z",
    fill: "#FFAFA3"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M204.83 125.782L204.343 127.525L210.323 129.199L210.811 127.455L204.83 125.782Z",
    fill: "#032335"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M194.837 125.291L188.727 126.398L189.049 128.179L195.16 127.072L194.837 125.291Z",
    fill: "#032335"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M194.12 134.481L193.17 134.441C193.2 133.701 192.63 133.061 191.88 133.031C191.14 133.001 190.5 133.571 190.47 134.321L189.52 134.281C189.58 133.011 190.66 132.031 191.92 132.091C193.19 132.151 194.17 133.231 194.11 134.491L194.12 134.481Z",
    fill: "#032335"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M207.73 135.12L206.78 135.08C206.81 134.34 206.24 133.7 205.49 133.67C204.75 133.64 204.11 134.21 204.08 134.96L203.13 134.92C203.19 133.65 204.27 132.67 205.53 132.73C206.8 132.79 207.78 133.87 207.72 135.13L207.73 135.12Z",
    fill: "#032335"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M182.66 126.171C182.66 126.171 192.98 119.981 211.15 123.611C211.15 123.611 214.13 132.481 220.4 136.391L226.38 123.711C226.38 123.711 227.9 116.491 221.8 113.591C221.8 113.591 217.01 103.021 199.84 104.381C182.67 105.751 182.66 126.161 182.66 126.161V126.171Z",
    fill: "#001E33"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M199.64 133.19C199.64 133.19 193.25 141.5 199.95 139.76",
    stroke: "#001E33",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M222.72 138.9C221.61 141.6 218.95 143 216.77 142.01C214.59 141.03 213.72 138.04 214.83 135.34C215.94 132.64 218.6 131.24 220.78 132.23C222.96 133.21 223.83 136.2 222.72 138.9Z",
    fill: "#FFAFA3"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M218.6 133.291L218.79 133.721C218.79 133.721 216.02 134.981 216.12 137.501L215.65 137.521C215.55 134.681 218.48 133.351 218.61 133.291H218.6Z",
    fill: "#001E33"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M197.76 124.25L199.69 118.8L199.71 124.25H197.76Z",
    fill: "#FFAFA3"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M200.65 124.53L201.7 120.21L202.14 124.38L200.65 124.53Z",
    fill: "#FFAFA3"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M194.85 144.5L203.94 143.98C203.94 143.98 203.96 147.65 199.6 147.9C195.24 148.15 194.84 144.5 194.84 144.5H194.85Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M220.43 144.75C219.02 144.75 217.87 143.6 217.87 142.19C217.87 141.47 218.17 140.78 218.7 140.3L219.38 141.05C219.06 141.34 218.88 141.76 218.88 142.19C218.88 143.04 219.57 143.74 220.43 143.74C221.29 143.74 221.98 143.05 221.98 142.19C221.98 141.76 221.68 141.17 221.4 140.89L222.12 140.17C222.56 140.61 223 141.44 223 142.19C223 143.6 221.85 144.75 220.44 144.75H220.43Z",
    fill: "#FDC73A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_698_4254",
    x1: 22.8101,
    y1: 150.18,
    x2: 33.3301,
    y2: 242.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_698_4254",
    x1: 525.47,
    y1: 180.4,
    x2: 512.92,
    y2: 290.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_698_4254",
    x1: 568.16,
    y1: 147.86,
    x2: 559.76,
    y2: 221.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_698_4254",
    x1: 687.9,
    y1: -58.0298,
    x2: 671.66,
    y2: 84.1002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_698_4254",
    x1: -88.3999,
    y1: -11.3596,
    x2: -69.0199,
    y2: 158.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_698_4254",
    x1: -154.32,
    y1: -61.6198,
    x2: -141.35,
    y2: 51.8602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailydose);
export default __webpack_public_path__ + "static/media/Daily dose.2b5ef7daeba45f02995076682829a479.svg";
export { ForwardRef as ReactComponent };